module.exports = __webpack_public_path__ + "img/14.d911e56b.jpg";